import { createApi } from "@reduxjs/toolkit/query/react";
import { dynamicBaseQuery } from "..";
import { TreeViewParams, TreeViewResponse } from "./TreeViewAPI.types";

export const treeViewApi = createApi({
  reducerPath: "treeViewApi",
  baseQuery: dynamicBaseQuery,
  endpoints: (builder) => ({
    getTreeView: builder.query<TreeViewResponse, TreeViewParams>({
      query: (params) => {
        const {
          Aff,
          Abo,
          Period,
          IsoCountryCode,
          Locale,
          IncludeAboAttr,
          IncludeAwardLevels,
          IncludeFrontline,
          IncludeGlobalMB,
          IncludeHasDownlineFlag,
          IncludeInactive,
          IncludeInactiveInGraceWindow,
          IncludeInternational,
          IncludeMap,
          IncludeSponStats,
          IncludeVolumeDetails,
          DeduplicateInternational,
          TimeZone,
        } = params;

        const queryParams = new URLSearchParams({
          Aff,
          Abo,
          Period,
          IsoCountryCode,
          Locale,
        });

        if (IncludeAboAttr !== undefined) {
          queryParams.append("IncludeAboAttr", String(IncludeAboAttr));
        }
        if (IncludeAwardLevels !== undefined) {
          queryParams.append("IncludeAwardLevels", String(IncludeAwardLevels));
        }
        if (IncludeFrontline !== undefined) {
          queryParams.append("IncludeFrontline", String(IncludeFrontline));
        }
        if (IncludeGlobalMB !== undefined) {
          queryParams.append("IncludeGlobalMB", String(IncludeGlobalMB));
        }
        if (IncludeHasDownlineFlag !== undefined) {
          queryParams.append("IncludeHasDownlineFlag", String(IncludeHasDownlineFlag));
        }
        if (IncludeInactive !== undefined) {
          queryParams.append("IncludeInactive", String(IncludeInactive));
        }
        if (IncludeInactiveInGraceWindow !== undefined) {
          queryParams.append("IncludeInactiveInGraceWindow", String(IncludeInactiveInGraceWindow));
        }
        if (IncludeInternational !== undefined) {
          queryParams.append("IncludeInternational", String(IncludeInternational));
        }
        if (IncludeMap !== undefined) {
          queryParams.append("IncludeMap", String(IncludeMap));
        }
        if (IncludeSponStats !== undefined) {
          queryParams.append("IncludeSponStats", String(IncludeSponStats));
        }
        if (IncludeVolumeDetails !== undefined) {
          queryParams.append("IncludeVolumeDetails", String(IncludeVolumeDetails));
        }
        if (DeduplicateInternational !== undefined) {
          queryParams.append("DeduplicateInternational", String(DeduplicateInternational));
        }
        if (TimeZone !== undefined) {
          queryParams.append("TimeZone", TimeZone);
        }
        return `/acc-action-report-v2-api/api/treeview?${queryParams}`;
      },
      extraOptions: { urlBase: "apiCFBaseUrl" },
    }),
  }),
});

export const { useGetTreeViewQuery, usePrefetch: useTreeViewPrefetch } = treeViewApi;
